import { Carousel } from '@mantine/carousel';
import { Paper } from '@mantine/core';
import { CarouselLayout } from '../Shares/CarouselLayout';
import { GameBattleCard } from './GameBattleCard';
import { gameBattles } from './data';
export const GameBattles: React.FC = () => {
  return <Paper bg="transparent">
      <CarouselLayout id="game-challenge" items={gameBattles} slideSize={{
      base: '50%',
      sm: '30%',
      md: '25%',
      xl: '20%'
    }}>
        {gameBattles.map(item => <Carousel.Slide key={item.id}>
            <GameBattleCard {...item} />
          </Carousel.Slide>)}
      </CarouselLayout>
    </Paper>;
};